import { createFileRoute } from '@tanstack/react-router';
import { DebtorDetail } from '~/components/debtor-detail';
import { isDebtorOrigin, isDebtorTabKey, type DebtorOrigin, type DebtorTabKey } from '~/lib/debtor-tabs';

export const Route = createFileRoute('/_authenticated/debiteuren/$debtorNumber')({
    validateSearch: (search: Record<string, unknown>): { tab?: DebtorTabKey; from?: DebtorOrigin } => ({
        tab: isDebtorTabKey(search.tab) ? search.tab : undefined,
        from: isDebtorOrigin(search.from) ? search.from : undefined,
    }),
    component: DebtorDetailPage,
});

function DebtorDetailPage() {
    const { debtorNumber } = Route.useParams();
    const { tab = 'overzicht', from } = Route.useSearch();
    const navigate = Route.useNavigate();

    return (
        <DebtorDetail
            key={debtorNumber}
            debtorNumber={debtorNumber}
            tab={tab}
            from={from}
            onTabChange={(next) => navigate({ search: (prev) => ({ ...prev, tab: next }), replace: true })}
        />
    );
}
